import { Injectable } from '@angular/core';
import { DbRecord } from './db-record'
import { ExportParserService } from './export-parser.service'

@Injectable()
export class PageService {
  recordsLength: number
  pageLength: number = 50
  currentStart = 0
  lastRecords: DbRecord[] = []

  constructor(
    private eprs: ExportParserService
  ) { }

  getPage(ls: DbRecord[]) {
    this.lastRecords = ls
    return ls.slice(this.currentStart, this.currentStart + this.pageLength)
  }

  export() {
    this.eprs.exportToFile(this.lastRecords)
  }

  exportJSON() {
    this.eprs.exportJSONToFile(this.lastRecords)
  }

  exportCSV() {
    this.eprs.exportCSVToFile(this.lastRecords)
  }

  exportHTML() {
    this.eprs.exportHTMLToFile(this.lastRecords)
  }

}



// WEBPACK FOOTER //
// ./src/app/page.service.ts